module.exports = "/v2/pages/dashboard/dist/5781967bed24fb85f724b9b45782b32c.svg";